<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		ControlsContainer,
		Text,
		IconButton,
		HeadingWithButton,
		Label,
		LabelV2,
		Popover,
		type DeviceButtonV2PropsTypes,
		type LabelV2PropsTypes,
	} from '@Shelly/shelly-design-system';
	import { getAutoChargeMode } from 'src/helpers/xt1_helpers/ev_charger/ev_charger_auto_charging_helpers';
	import { mapIconSolidWeightToLight } from 'src/helpers/new-layout-helpers';
	//Components
	import EvChargerControlButton from './EvChargerControlButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device,
		statuses: VCInterfaceStatus[],
		isWide = false,
		useV2Components = false;

	const deviceID: Device['id'] = device.id;
	export let deviceButtonV2Props: Partial<DeviceButtonV2PropsTypes> = {};
	export let labelV2Props: Partial<LabelV2PropsTypes> = {};

	let popover = false;

	$: autoChargingMode = getAutoChargeMode(deviceID, statuses);
</script>

{#if autoChargingMode}
	{#if isWide}
		<ControlsContainer>
			<svelte:fragment slot="first">
				<HeadingWithButton class="mb-m">
					<svelte:fragment slot="heading">
						{#if useV2Components}
							<LabelV2
								size="m"
								value={autoChargingMode.label}
								icon={mapIconSolidWeightToLight(autoChargingMode.labelIcon)}
								iconColor={autoChargingMode.labelIconColor}
								{...labelV2Props}
							/>
						{:else}
							<Label
								size="m"
								value={autoChargingMode.label}
								icon={autoChargingMode.labelIcon}
								iconColor={autoChargingMode.labelIconColor}
							/>
						{/if}
					</svelte:fragment>
					<Popover
						type="click"
						show={popover}
						placement="top-start"
						slot="button"
						hideCloseBtn
						on:close={() => (popover = false)}
					>
						<IconButton
							aria-label={$format('button_open_info', { default: 'Open info' })}
							shape="rounded"
							variant="secondary"
							icon="fa-solid fa-circle-info"
							on:click={() => (popover = !popover)}
						/>
						<svelte:fragment slot="customContent">
							<Text class="text-center" styleType="body-small">
								{$format('ev_charger_charging_btn_info', {
									default:
										'Auto mode starts charging automatically once the car is ready (Auto charge enabled in Settings). The button below lets you manually enable or disable charging in both modes.',
								})}
							</Text>
						</svelte:fragment>
					</Popover>
				</HeadingWithButton>
				<EvChargerControlButton {device} {autoChargingMode} isWide />
				<Text styleType="controls-large" class="mt-s text-bold">{autoChargingMode.btnTitle}</Text
				>
			</svelte:fragment>
		</ControlsContainer>
	{:else}
		<EvChargerControlButton {deviceButtonV2Props} {device} {autoChargingMode} />
	{/if}
{/if}
